module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userCountry !== '') ? _c('div', [(_vm.countries[_vm.userCountry]) ? _c('div', [_c(_vm.countries[_vm.userCountry].page, {
    tag: "component",
    attrs: {
      "data": _vm.countries[_vm.userCountry].data
    }
  })], 1) : _c('div', [_vm._v("Invalid country")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2300e19c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/withdraw-methods/mulix-wd-methods/mulix-payretailers.vue
// module id = 731
// module chunks = 0